import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'
import '../../../../Page/Connection/Connection.scss'

import Grid from '@material-ui/core/Grid'
import EurestoLogo from 'EurestoStyle/font/euresto_01.png'

const project = require('EurestoConfig/project.config')

class Connection extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      heightPanel: 0,
      messageErreur: [],
      passwordForgot: false
    }
  }

  handleClick = async () => {
    if ($('#password').val() === '' || $('#password').val() === undefined) {
      this.setState({
        messageErreur: ['Veuillez saisir votre nouveau mot de passe']
      })
      return
    } else if ($('#password2').val() === '' || $('#password2').val() === undefined) {
      this.setState({
        messageErreur: ['Veuillez confirmer votre nouveau mot de passe']
      })
      return
    } else if ($('#password').val() !== $('#password2').val()) {
      this.setState({
        messageErreur: ['Les mots de passe saisis ne sont pas identiques']
      })
      return
    }
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'change_password',
      key_generator: this.props.params.key_generator,
      password1: $('#password').val(),
      password2: $('#password2').val()
    }, { returnAnyway: true })
    if (result.code === 1) {
      window.location = result.link
    } else {
      this.setState({
        messageErreur: [result.message]
      })
    }
  }

  componentDidMount () {
    this.setState({
      heightPanel: $('#ConnectionEurestoPanel').height()
    })
  }

  deleteMessageErreur = _ => {
    this.setState({
      messageErreur: []
    })
  }

  render () {
    const { passwordForgot } = this.state
    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100vh' }} direction="column" justify="center"
            alignItems="center" className="EurestoBodyConnection grad">


        <Grid id={'ConnectionEurestoPanel'} item style={{
          margin: 0, padding: 0, position: 'relative',
          zIndex: 11,
        }} lg={2} md={4} sm={4} xs={6}
              onKeyPress={(e) => {
                if (e.charCode === 13) {
                  this.handleClick()
                } else if (this.state.messageErreur.length > 0) this.deleteMessageErreur()
              }}>

          <Grid container style={{
            margin: 0,
            padding: 0,
            height: 'auto',
            zIndex: 11,
            position: 'absolute',
            bottom: $('#ConnectionEurestoPanel').innerHeight(),
            fontSize: 20, width: '100%', textAlign: 'center'
          }} direction="column" justify="center" alignItems="stretch">
            {
              this.state.messageErreur.map((msg, i) => (
                <div className={'EurestoText--text EurestoError'} style={{
                  width: '100%',
                  padding: 5,
                  fontSize: 12,
                  marginBottom: 15,
                  textAlign: 'justify',
                  position: 'relative',
                  borderRadius: 10
                }}>{msg}
                </div>
              ))
            }
          </Grid>
          <Grid container style={{
            zIndex: 10,
            margin: 0,
            padding: 0,
            position: 'relative',
            paddingBottom: 10,
            textAlign: 'center',
            background: 'rgb(0, 36, 49)',
            borderRadius: '10px',
          }} direction="column" justify="center" alignItems="stretch">
            <img alt='Bandeau euresto' width="100%" style={{ marginTop: 0, minHeight: '1%' }} src={EurestoLogo}/>
            <span className={'EurestoText--text'}
                  style={{
                    fontSize: 18,
                    textAlign: 'middle',
                    padding: 15,
                    paddingBottom: 0,
                    fontWeight: 'lighter'
                  }}
            >Créez un nouveau mot de passe</span>
            <Grid container style={{
              margin: '10px 10px 0px 10px', padding: 0,
              borderRadius: '5px', position: 'relative', width: 'calc(100% - 20px)',
              border: '3px solid rgb(0, 159, 132)',
            }} spacing={0} justify="center"
                  alignItems="center">

              <Grid container style={{
                margin: 0,
                padding: 0,
                width: '15%',
                backgroundColor: 'rgb(0, 36, 49)',
                borderRight: '3px solid rgb(0, 159, 132)',
                height: '40px',
              }} direction="column" justify="center" alignItems="stretch">
                <i className="fa fa-key fa-2x EurestoText--text"/>
              </Grid>
              <input style={{
                backgroundColor: 'white',
                color: 'black',
                marginTop: 0,
                width: '85%',
                height: '40px',
                fontSize: '18px',
              }} id="password" type="password"
                     placeholder=" Nouveau mot de passe"/>
            </Grid>
            <Grid container style={{
              margin: '10px 10px 0px 10px', padding: 0,
              borderRadius: '5px', position: 'relative', width: 'calc(100% - 20px)',
              border: '3px solid rgb(0, 159, 132)',
            }} spacing={0} justify="center"
                  alignItems="center">

              <Grid container style={{
                margin: 0,
                padding: 0,
                width: '15%',
                backgroundColor: 'rgb(0, 36, 49)',
                borderRight: '3px solid rgb(0, 159, 132)',
                height: '40px',
              }} direction="column" justify="center" alignItems="stretch">
                <i className="fa fa-key fa-2x EurestoText--text"/>
              </Grid>
              <input style={{
                backgroundColor: 'white',
                color: 'black',
                marginTop: 0,
                width: '85%',
                height: '40px',
                fontSize: '18px',
              }} id="password2" type="password"
                     placeholder=" Confirmez le mot de passe"/>
            </Grid>
            <button style={{
              border: '3px solid rgb(0, 159, 132)',
              backgroundColor: 'white',
              width: 'calc(100% - 20px)',
              height: '40px',
              borderRadius: '5px',
              fontSize: '18px',
              margin: '10px 10px 0px 10px'
            }}
                    onClick={this.handleClick}>{'Confirmer'}
            </button>
          </Grid>
        </Grid>

      </Grid>
    )
  }
}

export default Connection



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/ModificationMotDePasse/index.js